import apiFactory from '../config/api-factory';
import { Content } from '../models/content/types';

export type AliasData = {
  id: number;
  attributes: {
    display_name: string;
    avatar_url: string | null;
    alias_type: string;
    description: string | null;
  };
};

export type AliasContentItem = {
  type: string;
  id: string;
  attributes: Content;
};

export type AliasContentsResponse = {
  contents: AliasContentItem[];
  meta: {
    page: { size: number; number: number };
    total?: number;
  } | null;
};

export function fetchAlias(id: string) {
  return apiFactory.v2.get<{ data: AliasData }>(`/author_aliases/${id}`);
}

export function fetchAliasContents(id: string, page = 1, pageSize = 20) {
  return apiFactory.v2.get<AliasContentsResponse>(
    `/author_aliases/${id}/contents`,
    { params: { page, page_size: pageSize } }
  );
}
